export enum TouchpointDeviceType {
  web = 'web',
  wt3 = 'wt3',
  wt2 = 'wt2',
}
